import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const RecieptIconLarge: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 18.6458V8.05426C4 5.20025 4 3.77325 4.87868 2.88663C5.75736 2 7.17157 2 10 2H14C16.8284 2 18.2426 2 19.1213 2.88663C20 3.77325 20 5.20025 20 8.05426V18.6458C20 20.1575 20 20.9133 19.538 21.2108C18.7831 21.6971 17.6161 20.6774 17.0291 20.3073C16.5441 20.0014 16.3017 19.8485 16.0325 19.8397C15.7417 19.8301 15.4949 19.9768 14.9709 20.3073L13.06 21.5124C12.5445 21.8374 12.2868 22 12 22C11.7132 22 11.4555 21.8374 10.94 21.5124L9.02913 20.3073C8.54415 20.0014 8.30166 19.8485 8.03253 19.8397C7.74172 19.8301 7.49493 19.9768 6.97087 20.3073C6.38395 20.6774 5.21687 21.6971 4.46195 21.2108C4 20.9133 4 20.1575 4 18.6458Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 11H8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 7H8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RecieptIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66602 12.4292L2.66602 5.3682C2.66602 3.46553 2.66602 2.5142 3.2518 1.92312C3.83759 1.33203 4.7804 1.33203 6.66602 1.33203L9.33268 1.33203C11.2183 1.33203 12.1611 1.33203 12.7469 1.92312C13.3327 2.5142 13.3327 3.46553 13.3327 5.3682V12.4292C13.3327 13.437 13.3327 13.9409 13.0247 14.1392C12.5214 14.4634 11.7434 13.7836 11.3521 13.5369C11.0287 13.333 10.8671 13.231 10.6877 13.2252C10.4938 13.2188 10.3293 13.3166 9.97995 13.5369L8.70602 14.3403C8.36235 14.557 8.19055 14.6654 7.99935 14.6654C7.80815 14.6654 7.63635 14.557 7.29268 14.3403L6.01877 13.5369C5.69545 13.333 5.53379 13.231 5.35437 13.2252C5.1605 13.2188 4.99597 13.3166 4.6466 13.5369C4.25532 13.7836 3.47726 14.4634 2.97398 14.1392C2.66602 13.9409 2.66602 13.437 2.66602 12.4292Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33398 7.33203H5.33398"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33398 4.66797H5.33398"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
